import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">

          {/* Brand Column */}
          <div className="md:col-span-2 space-y-5">
    
    {/* Logo with Claim Assessment Document Icon & Gradient Text */}
              <Link to="/" className="flex items-center gap-[5px] group">
                <svg 
                  className="w-10 h-10 transition-transform duration-500 ease-out group-hover:-translate-y-1" 
                  viewBox="0 0 100 100" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <defs>
                    <linearGradient id="logoPremiumGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#b91c1c" />
                      <stop offset="100%" stopColor="#ef4444" />
                    </linearGradient>
                    <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
                      <feDropShadow dx="0" dy="2" stdDeviation="4" floodColor="#ef4444" floodOpacity="0.5"/>
                    </filter>
                  </defs>
                  
                  {/* The Document Base */}
                  <path 
                    d="M30 15 H60 L80 35 V80 A5 5 0 0 1 75 85 H30 A5 5 0 0 1 25 80 V20 A5 5 0 0 1 30 15 Z" 
                    className="fill-slate-900 stroke-white group-hover:stroke-white-600 transition-colors duration-300" 
                    strokeWidth="4" 
                    strokeLinejoin="round"
                  />
                  
                  {/* The Folded Corner of the Document */}
                  <path 
                    d="M60 15 V35 H80" 
                    className="stroke-white group-hover:stroke-white transition-colors duration-300" 
                    fill="none" 
                    strokeWidth="4" 
                    strokeLinejoin="round"
                  />
                  
                  {/* Abstract Lines representing the Assessment Form */}
                  <line x1="38" y1="35" x2="48" y2="35" className="stroke-white" strokeWidth="4" strokeLinecap="round"/>
                  <line x1="38" y1="48" x2="68" y2="48" className="stroke-white" strokeWidth="4" strokeLinecap="round"/>
                  <line x1="38" y1="61" x2="55" y2="61" className="stroke-white" strokeWidth="4" strokeLinecap="round"/>
    
                  {/* The "Trusted Option" Checkmark popping out */}
                  <path 
                    d="M30 65 L45 80 L90 35" 
                    stroke="url(#logoPremiumGradient)" 
                    strokeWidth="8" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    filter="url(#glow)"
                    className="transform origin-center group-hover:scale-110 transition-transform duration-300"
                  />
                </svg>
                <span className="text-2xl font-extrabold tracking-tighter text-white uppercase">
                  Trusted<span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-600">Options</span>
                </span>
              </Link>

              

            <p className="text-slate-400 text-sm max-w-md leading-relaxed">
              Trustedoptions is a secure assessment portal providing free eligibility reviews and matched legal introductions across Personal Injury, Financial Mis-selling, Housing Disrepair, and more.
            </p>
            <div className="flex gap-3 pt-2">
              <span className="inline-block text-[10px] uppercase font-bold text-slate-500 border border-slate-800 px-3 py-1.5 rounded bg-slate-900">
                SSL Secured
              </span>
              <span className="inline-block text-[10px] uppercase font-bold text-slate-500 border border-slate-800 px-3 py-1.5 rounded bg-slate-900">
                GDPR Compliant
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-red-500 mb-5">Navigation</p>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-slate-400 hover:text-white transition-colors font-medium">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/contact/" className="text-slate-400 hover:text-white transition-colors font-medium">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-red-500 mb-5">Legal</p>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/privacy-policy/" className="text-slate-400 hover:text-white transition-colors font-medium">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms/" className="text-slate-400 hover:text-white transition-colors font-medium">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy/" className="text-slate-400 hover:text-white transition-colors font-medium">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-center mx-auto">
            <p className="text-xs text-slate-500 font-medium">
              &copy; {new Date().getFullYear()} Trustedoptions Ltd. All Rights Reserved. Trustedoptions is a matching gateway, not a solicitors firm or legal provider.
            </p>
            <p className="text-[10px] text-slate-600 mt-1">
              Registered Office: 85 Great Portland Street, London, W1W 7LT. Company No. 12948123.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
